<div class="card">
    <div class="card-body" style="overflow-x: auto;">
        <div class="d-flex justify-content-end mb-3" *ngIf="hasSeoStarterSubscription">
            <button type="button" class="btn btn-outline-primary"
                (click)="generateMonthlyPdfReport()">
                <i class="fa fa-file-pdf me-1"></i>
                Generate Monthly PDF Report
            </button>
        </div>
        <app-tab-panel [displayMode]="tabPanelDisplayMode.horizontal">
            <app-tab [title]="'Files'">
                <app-components-customerfiles *tabContent [options]="{
                        customerId: customerId,
                        fileSectionTypeId: FileSectionTypes.General,
                        showFileSectionSelector: false,
                        fileSectionTypeIds: [
                            FileSectionTypes.BoostSite,
                            FileSectionTypes.General,
                            FileSectionTypes.KeywordResearch,
                            FileSectionTypes.LocalProfile,
                            FileSectionTypes.Marketing,
                            FileSectionTypes.Ranks
                        ],
                        canDelete: true,
                        canUpload: true
                }"></app-components-customerfiles>
            </app-tab>
            <app-dynamic-tab [title]="'Custom Reports'">
                <compose *tabContent Selector="app-components-customreports" [ActivateOptions]="{
                        allowDelete: true,
                        customer: customer,
                        showAddNew: true
                    }"></compose>
            </app-dynamic-tab>
        </app-tab-panel>
    </div>
</div>